
import { Vue, Options, prop } from "vue-class-component";
import ProductPriceInsurance from "./product-price-insurance/index.vue";
import WeightKoli from "./weight-koli/index.vue";
import { SttAdjustmentRule } from "@/domain/entities/ShipmentBooking";
import { Insurance } from "@/domain/entities/Insurance";
import { HeavyWeightSurchargeDetailMinimum } from "@/domain/entities/HeavyWeightSurcharge";
import { PropType } from "vue";
import { InsuranceTypeDeliveryData } from "@/domain/entities/Booking";
import { DestinationCity } from "@/domain/entities/CreateBookingV3";

class Props {
  pieces = prop<any>({
    required: true
  });
  form = prop<any>({
    required: true
  });
  formType = prop<string>({
    default: "",
    type: String
  });
  errorEstimationPrice = prop<any>({
    required: true
  });
  listCodActive = prop<any>({
    required: true
  });
  listDfodActive = prop<any>({
    required: true
  });
  showWarningHwsProp = prop<boolean>({
    required: true
  });
  isErrorHws = prop<boolean>({
    required: true
  });
  isCampaign = prop<boolean>({
    required: true
  });
  errorEmbargo = prop<any>({
    required: true
  });
  maxPieces = prop<number>({
    required: true
  });
  isInterpackLanePending = prop<boolean>({
    type: Boolean,
    default: false
  });
  currentIndex = prop<number>({
    required: true
  });
  pieceIndex = prop<number>({
    required: true
  });
  goodsPriceIndex = prop<number>({
    required: true
  });
  configGoodsPrice = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configInsurance = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configCodAmount = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configGrossWeight = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configDimension = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configAdjustPiece = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  insuranceData = prop<Insurance>({
    required: true
  });
  hwsMinimumData = prop<HeavyWeightSurchargeDetailMinimum>({
    required: true
  });
  isRebookingFlow = prop<boolean>({
    default: false
  });
  tempPieces = prop<any>({
    default: []
  });
  disabledWeight = prop<boolean>({
    default: false
  });
  disabledDimension = prop<boolean>({
    default: false
  });
  configAdjustPieceAdd = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  configAdjustPieceRemove = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  listKgDefault = prop<any>({
    default: []
  });
  isEditForm = prop<boolean>({
    default: false
  });
  isEditSttMY = prop<boolean>({
    default: false
  });
  isShipment = prop<boolean>({
    default: false
  });
  dataRuleShipmentBooking = prop<any>({
    required: true
  });
  eligibleEditSize = prop<boolean>({
    default: false
  });
  isBookingShipment = prop<boolean>({
    default: false
  });
  totalChargeableWeight = prop<number>({
    default: 0,
    type: Number
  });
  bookingType = prop<string>({
    default: "",
    type: String
  });
  schemaGoodsPriceType = prop<"retail" | "client" | "shipment_ca">({
    default: "retail",
    type: String as PropType<"retail" | "client" | "shipment_ca">
  });
  excludeEstimationValidation = prop<boolean>({
    default: false
  });
  insuranceBasic = prop<InsuranceTypeDeliveryData>({
    default: () => new InsuranceTypeDeliveryData(),
    type: Object
  });
  isRetail = prop<boolean>({
    default: false,
    type: Boolean
  });
  isForceShowInsurance = prop<boolean>({
    default: false,
    type: Boolean
  });
  destination = prop<DestinationCity>({
    default: () => new DestinationCity(),
    type: Object
  });
  isFirstRender = prop<boolean>({
    default: false,
    type: Boolean
  });
  isEdit = prop<boolean>({
    default: false,
    type: Boolean
  });
  isCrossCountryRoute = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  emits: [
    "update:form",
    "update:pieces",
    "update:currentIndex",
    "updateGrossWeight"
  ],
  components: {
    ProductPriceInsurance,
    WeightKoli
  }
})
export default class Banner extends Vue.with(Props) {
  get totalPieces() {
    return this.pieces;
  }

  set totalPieces(value) {
    this.$emit("update:pieces", value);
  }

  get formData() {
    return this.form;
  }

  set formData(value: any) {
    this.$emit("update:form", value);
  }

  get errorIndex() {
    return this.currentIndex;
  }

  set errorIndex(value) {
    this.$emit("update:currentIndex", value);
  }

  get showWarningHwsPropModel() {
    return this.showWarningHwsProp;
  }

  set showWarningHwsPropModel(val: boolean) {
    this.$emit("update:showWarningHwsProp", val);
  }

  onResetInsurance() {
    this.formData.insurance = "free";
  }
}
